import { call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { setCallRecording } from '../../../state/callRecording/callRecordingSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { backendClient } from '../../../services/api/backend-client';

export function* fetchCallRecordingSaga(action) {
  const callId = action.payload;
  const { domain } = yield select(selectUserCredentials);
  try {

    const { data } = yield call(
      [backendClient, backendClient.get],
      'recordings/url',
      { params: { callId, domain } }
    );
    const recordingUrl = data?.recordingUrl;
    if (!recordingUrl) {
      console.error('No recording URL returned');
      return;
    }
    yield put(setCallRecording({ callId, recordingUrl }));

  } catch (error) {
    const status = error?.response?.status;
    console.error('Error fetching call recordings:', status, error?.message);
  }
}